import React from "react";
import { RefreshCw, TrendingDown, Utensils, Clock, HelpCircle, UserX } from "lucide-react";
import LpCta from "./LpCta";
import { PAIN_ITEMS } from "./lpData";

const ICONS = [TrendingDown, RefreshCw, Utensils, Clock, HelpCircle, UserX];

const LpPain = () => (
  <section className="section-pad bg-white" data-testid="lp-pain">
    <div className="aevos-container">
      <div className="max-w-3xl">
        <h2 className="font-display font-bold text-3xl md:text-5xl leading-[1.08]">
          Você já tentou emagrecer, mas sente que está sempre recomeçando?
        </h2>
        <p className="mt-5 text-[#333333] text-base md:text-lg leading-relaxed">
          Mudar a alimentação, aumentar os treinos e depois ver o peso voltar pode ser frustrante.
          Principalmente quando falta clareza sobre o que precisa mudar e como manter esse cuidado
          na sua rotina.
        </p>
      </div>

      <ul className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="lp-pain-list">
        {PAIN_ITEMS.map((item, i) => {
          const Icon = ICONS[i];
          return (
            <li key={item} className="aevos-card p-6 flex gap-4 items-start">
              <span className="w-10 h-10 flex-shrink-0 bg-[#E6F8FF] flex items-center justify-center">
                <Icon size={20} className="text-[#00C4FF]" />
              </span>
              <span className="text-[#333333] text-sm md:text-base leading-relaxed">{item}</span>
            </li>
          );
        })}
      </ul>

      <div className="mt-12">
        <LpCta location="pain">Quero uma avaliação individualizada</LpCta>
      </div>
    </div>
  </section>
);

export default LpPain;
